module.exports = __webpack_public_path__ + "static/media/mtn50-aragon.c84c934b.geojson";